import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { SubscriptionStatus } from "./Data/ApiTransport";
import { Vehicle } from "./Data/ApiTypes";
import { ReservationVehicleCard } from "./ReservationVehicleCard";
import { ServerRequestsParkerIntegrationPartyDto } from "./shared/api/axios-client";
import { gridOneCol } from "./Data/Common";
import { PageBar } from "./Controls/PageBar";
type Props = {
  vehicles: Vehicle[];
  subscriptionStatus: SubscriptionStatus;
  facilityId: number;
  subscriptionId: number;

  integrations: ServerRequestsParkerIntegrationPartyDto[];

  onAddNew(): void;
  onAddExisting(): void;
  onRemove(vehicle: Vehicle): void;

  setPendingToggle: React.Dispatch<React.SetStateAction<any>>;
  setShowToggleConfirm: React.Dispatch<React.SetStateAction<boolean>>;

  showVehiclesLabel?: boolean;
};

export const VehiclesSection = ({
  vehicles,
  subscriptionStatus,
  facilityId,
  subscriptionId,
  integrations,
  onAddNew,
  onAddExisting,
  onRemove,
  setPendingToggle,
  setShowToggleConfirm,
  showVehiclesLabel = false,
}: Props) => {
  const actions =
    subscriptionStatus === SubscriptionStatus.Active ? (
      <>
        <Link
          to=""
          onClick={(e) => {
            e.preventDefault();
            onAddNew();
          }}
        >
          Add New
        </Link>
        &nbsp;|&nbsp;
        <Link
          to=""
          onClick={(e) => {
            e.preventDefault();
            onAddExisting();
          }}
        >
          Add Existing
        </Link>
      </>
    ) : null;

  return (
    <Container fluid>
      <Row>
        <Col style={gridOneCol("max-content 1fr 5px")}>
          {showVehiclesLabel && (
            <Row className="align-items-center justify-content-between">
              <Col>
                <PageBar title="Vehicles" />
              </Col>
              <Col xs="auto">{actions}</Col>
            </Row>
          )}

          <Card className="mb-4">
            {!showVehiclesLabel && (
              <Card.Header
                style={{
                  display: "grid",
                  gridTemplateColumns: "max-content 1fr max-content",
                }}
              >
                <div>Vehicles</div>
                <div />
                <div>{actions}</div>
              </Card.Header>
            )}

            <Card.Body>
              {vehicles.length === 0 ? (
                <div className="text-secondary">
                  This parker hasn’t added any vehicles yet.
                </div>
              ) : (
                vehicles.map((v) => (
                  <ReservationVehicleCard
                    key={v.vehicleId}
                    vehicle={v}
                    subscriptionStatus={subscriptionStatus}
                    facilityId={facilityId}
                    subscriptionId={subscriptionId}
                    onRemove={() => onRemove(v)}
                    integrations={integrations}
                    setPendingToggle={setPendingToggle}
                    setShowToggleConfirm={setShowToggleConfirm}
                  />
                ))
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
